<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <!-- start: PAGE TITLE -->
      <section id="page-title" style="background-color: #d1d1d1;">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">All Banners</h1>
          </div>
          <div class="col-sm-2">
            <router-link v-if="hasPermission('banner create')" style="margin-right: 10px" class="btn btn-primary"
              :to="{ name: 'create-banner' }">create</router-link>
            <router-link v-if="hasPermission('banner getSoftDeleted')" class="btn btn-success"
              :to="{ name: 'deleted-banners' }">Deleted
              Banner</router-link>
          </div>

        </div>
      </section>
      <!-- end: PAGE TITLE -->
      <!-- start: DYNAMIC TABLE -->
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-12">

            <div v-if="banner.length > 0">

              <MyTable :columns="columns" :actions="true">
                <tr v-for="(Banner, index) in filteredBanners" :key="index">
                  <th scope="row">{{ Banner.id }}</th>
                  <td>{{ Banner.bannerable_type }}</td>
                  <td>{{ Banner.related ? Banner.related.name_en : 'N/A' }}</td>
                  <td>{{ Banner.banner == 1 ? 'True' : 'False' }}</td>
                  <td>
                    <img :src="`${Banner.image}`" width="50" height="50" class="img-thumbnail" />
                  </td>
                  <td>
                    <button class="me-2 btn btn-danger" v-if="hasPermission('banner delete')"
                      @click="deleteBanner(Banner.id)">
                      Delete
                    </button>
                    <router-link v-if="hasPermission('banner update')" class="btn btn-primary spacing"
                      :to="{ name: 'edit-banner', params: { id: Banner.id } }">
                      Edit
                    </router-link>
                  </td>
                </tr>
              </MyTable>
            </div>
            <div v-else class="alert alert-info">
              No Banner found.
            </div>
          </div>
        </div>
      </div>
      <!-- end: DYNAMIC TABLE -->
    </div>
  </div>
</template>

<script>
import $ from 'jquery'; // Import jQuery
import { store } from "../../Store";
import MyTable from "../MyTable//MyTable.vue";
import axios from "../../Axios";
export default {
  name: "AllBanners",
  components: {
    MyTable,
    // Paginate,
  },
  data() {
    return {
      dataTable: [],
      banner: [],
      meta: {},
      searchTerm: "",
      columns: [
        { label: '#', key: 'id' },
        { label: 'Banner Type', key: 'bannerable_type' },
        { label: 'Banner For', key: 'related.name' },
        { label: 'banner', key: 'banner' },
        { label: 'Image', key: 'image' },
      ],
    };
  },

  async created() {
    this.fetchBanners();
  },
  computed: {
    hasPermission() {
      return (permission) => store.hasPermission(permission);
    },
    filteredBanners() {
      if (!this.searchTerm) {
        return this.banner;
      }
      const term = this.searchTerm.toLowerCase();
      return this.banner.filter(
        (Banner) =>
          Banner.name.toLowerCase().includes(term)
      );
    },
  },

  methods: {
    // fetch orders
    async fetchBanners() {
      try {
        const response = await axios.get(
          `/admin/admin/offer/all`
        );
        this.banner = response.data.data;
        console.log(this.banner);
        this.meta = response.data.meta;
        this.$nextTick(() => {
          this.initializeDataTable(); // Initialize DataTable after fetching users
        });
      } catch (error) {
        console.error("Error fetching Banners:", error);
      }
    },
    initializeDataTable() {
      this.$nextTick(() => {
        // Ensure the DataTable is initialized only after the DOM is updated
        $('.sample_1').DataTable(); // Initialize DataTable
      });
    },
    deleteBanner(id) {
      console.log("delete banner id: ", id);
      axios
        .delete(`/admin/admin/offer/delete?id=${id}`)
        .then((response) => {
          console.log(response.data);
          this.fetchBanners();
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style scoped>
.table {
  margin-top: 10px;
}

.spacing {
  margin-left: 10px !important;
}
</style>